require('./index.scss')
import { useSelector } from 'react-redux'

import { isPrintAssetSelector, returnPolicyLinkTextSelector } from '@/selectors'
import { newRouteFor } from '@/utils/router'
import settings from '@/utils/settings'
import { translate } from '@/utils/translations'

import Header from './Header'
import PolicyStatement from './PolicyStatement'
import PolicyStatementPrint from './PolicyStatementPrint'

const ReturnPolicy = () => {
  const allPoliciesLinkText = useSelector(returnPolicyLinkTextSelector)
  const isPrintAsset = useSelector(isPrintAssetSelector)
  const policyUrl = isPrintAsset
    ? settings.virtual_store_return_policy_link_url
    : `${newRouteFor('/refund-policy')}#exceptions`

  return (
    <div>
      <Header />
      {
        isPrintAsset
          ? <PolicyStatementPrint />
          : <PolicyStatement />
      }
      <a
        className='underline'
        href={policyUrl}
        rel='noreferrer'
        target='_blank'
      >
        {allPoliciesLinkText}
        <span className="sr-only">
          {translate('common.opens_in_new_window')}
        </span>
      </a>
    </div>
  )
}

export default ReturnPolicy
